import * as React from 'react';
import clx from 'classnames';
import { Col, Typography, Card, Alert, Space, Row } from 'antd';
const { Title } = Typography;
import './DesktopOnlyAfterContent.scss';
import { SpaceProps } from 'antd/lib/space';

export interface DesktopOnlyAfterContentProps {
  children?: React.ReactNode;
}

/**
 * Sezione per visualizzare i pulsanti di invio domanda
 * alla fine del form (solo desktop)
 */
export function DesktopOnlyAfterContent(props: DesktopOnlyAfterContentProps) {
  return (
    <Row style={{ padding: '0 12px' }}>
      <Col span={18} offset={6}>
        {props.children}
      </Col>
    </Row>
  );
}
